import React, { useState } from "react";
import "./AssessmentDrawer.css";
import AssessmentForm from "../forms/AssessmentForm";
import useAuth from "../../hooks/useAuth";

const AssessmentDrawer = ({ onClose }) => {
  const { authFetch } = useAuth();
  const [remarks, setRemarks] = useState("");
  const [showRemarksField, setShowRemarksField] = useState(false);
  const [actionType, setActionType] = useState("");
  

  const handleApiCall = async (endpoint, data) => {
    try {
      const response = await authFetch(`https://internalhrms.vdcapp.in/backend/api/${endpoint}`, {
        method: 'POST',
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.status) {
        console.log("Action successful:", result);
        onClose();
      } else {
        alert('Error: ' + (result.message || 'Unknown error'));
      }
    } catch (error) {
      console.error('API Error:', error);
      alert('Failed to complete action. Please try again.');
    }
  };

  const handleAccept = async () => {
    await handleApiCall('acceptAssessment', { 
      status: 'accepted' 
      // Add other necessary data like candidate ID
    });
  };

  const handleReject = async () => {
    if (!showRemarksField) {
      setShowRemarksField(true);
      setActionType('reject');
    } else if (remarks.trim()) {
      await handleApiCall('rejectAssessment', { 
        status: 'rejected',
        remarks: remarks.trim()
        // Add other necessary data
      });
    }
  };

  const handleHold = async () => {
    if (!showRemarksField) {
      setShowRemarksField(true);
      setActionType('hold');
    } else if (remarks.trim()) {
      await handleApiCall('holdAssessment', { 
        status: 'hold',
        remarks: remarks.trim()
        // Add other necessary data
      });
    }
  };

  const handleSubmitRemarks = async () => {
    if (remarks.trim()) {
      if (actionType === 'reject') {
        await handleReject();
      } else if (actionType === 'hold') {
        await handleHold();
      }
    }
  };

  const handleCancelRemarks = () => {
    setShowRemarksField(false);
    setRemarks("");
  };

  return (
    <div className="assessment-drawer-overlay">
      <div className="assessment-drawer">
        <div className="drawer-header">
          <h3>New Radiology Assessment</h3>
          <button className="close-btn" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="drawer-content">
          <AssessmentForm />
          
{/* Action buttons section */}
<div className="action-buttons-container">
  {showRemarksField ? (
    <div className="remarks-section">
      <h4>Add Remarks</h4>
      <textarea
        className="remarks-textarea"
        placeholder="Enter your remarks here..."
        value={remarks}
        onChange={(e) => setRemarks(e.target.value)}
        rows={3}
      />
      <div className="remarks-buttons">
        <button 
          className="btn btn-submit" 
          onClick={handleSubmitRemarks}
          disabled={!remarks.trim()}
        >
          Submit Remarks
        </button>
        <button 
          className="btn btn-cancel" 
          onClick={handleCancelRemarks}
        >
          Cancel
        </button>
      </div>
    </div>
  ) : (
    <div className="action-buttons">
      <button 
        className="btn btn-accept" 
        onClick={handleAccept}
      >
        Accept
      </button>
      <button 
        className="btn btn-hold" 
        onClick={handleHold}
      >
        Hold
      </button>
      <button 
        className="btn btn-reject" 
        onClick={handleReject}
      >
        Reject
      </button>
    </div>
  )}
</div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentDrawer;